export default __webpack_public_path__ + "static/media/entrepreneur.7962dbb2.svg";